export default __webpack_public_path__ + "img/TourStep2.png";